/* ACARRi white-wall gallery view: one switch, remembered across pages (per visitor). */
(() => {
  const KEY = 'acarri-wall';
  let on = true; // white wall is the default; '0' means the visitor chose the dark room
  try { on = localStorage.getItem(KEY) !== '0'; } catch (e) {}
  const apply = () => {
    document.documentElement.classList.toggle('acarri-white-wall', on);
    document.querySelectorAll('[data-wall-toggle]').forEach((b) => {
      b.setAttribute('aria-pressed', String(on));
      const l = b.querySelector('[data-wall-label]');
      if (l) l.textContent = on ? 'Dark room' : 'White wall';
    });
  };
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-wall-toggle]')) return;
    on = !on;
    try { localStorage.setItem(KEY, on ? '1' : '0'); } catch (err) {}
    apply();
  });
  apply();
})();
